<template>
  <el-container class="view-content">
    <el-header class="header-content">
      <el-form :model="searchItem" label-width="auto" inline size="small">
        <el-form-item label="设备ID">
          <el-input v-model.trim="searchItem.device_id" clearable></el-input>
        </el-form-item>
        <el-form-item label="所属商家">
          <el-input v-model.trim="searchItem.shop_name" clearable></el-input>
        </el-form-item>
        <el-form-item label="在线状态">
          <el-select v-model="searchItem.online" clearable>
            <el-option v-for="item in deviceOnline" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备类型">
          <el-select v-model="searchItem.type" clearable>
            <el-option v-for="item in deviceType" :key="item.id" :value="item.id" :label="item.msg"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备型号">
          <el-input v-model.trim="searchItem.model" clearable></el-input>
        </el-form-item>
        <el-form-item label="SN">
          <el-input v-model.trim="searchItem.sn" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model.trim="searchItem.name" clearable></el-input>
        </el-form-item>
        <el-form-item label="设备版本">
          <el-input v-model.trim="searchItem.sversion" clearable></el-input>
        </el-form-item>
        <el-form-item label="插件版本">
          <el-input v-model.trim="searchItem.pversion" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
      <el-row type="flex" justify="space-between" align="middle">
        <statistics :count-list="countList"/>
      </el-row>
    </el-header>
    <el-main class="main-content">
      <vue-table :table-data="tableData">
        <template slot="shopName" slot-scope="{row}">
          <template v-if="row.shop">
            <el-button class="black" type="text" @click="$router.push({path: '/shop/list', query: {shop_id: row.shop_id}})">
              {{row.shop.name}}
            </el-button>
          </template>
          <template v-else>-</template>
        </template>
        <template slot="sversion" slot-scope="scope">
          <span class="cell-content">{{scope.row.sversion}}</span>
          <div class="cell-tips">
            <el-popover
              placement="top-start"
              trigger="hover">
              <span>最新版本：{{scope.row.latest_sversion}}</span>
              <p slot="reference" class="content background-danger" v-if="scope.row.latest_sversion">可升级</p>
            </el-popover>
          </div>
        </template>
        <template slot="start_at" slot-scope="scope">
          <span>{{formatRuntime(scope.row)}}</span>
        </template>
        <template slot="actionBar">
          <el-table-column align="center" label="操作栏" :resizable="false" width="130">
            <template slot-scope="scope">
              <el-button type="text" @click="remote(scope.row, 'router')" :disabled="!scope.row.online">远程路由</el-button>
              <el-button type="text" @click="remote(scope.row, 'ac')" :disabled="!scope.row.online">远程AC</el-button>
<!--              <el-button type="text" @click="remote(scope.row, 'telnet')" :disabled="!scope.row.online">Telnet</el-button>-->
            </template>
          </el-table-column>
        </template>
      </vue-table>
    </el-main>
    <el-footer class="footer-content">
      <vue-pagination :paging-data="pagingData" @table-reload="getTableList" ref="paging"/>
    </el-footer>
  </el-container>
</template>

<script>
  import {PagingData} from "@mixins"
  import Statistics from "@view/components/Statistics"
  import {deviceOnline,deviceType,deviceFunction} from "@utils/formatList"
  export default {
    name: "deviceList",
    mixins: [PagingData],
    components: {Statistics},
    data() {
      return {
        deviceOnline,
        deviceType,
        // 查询项
        searchItem: {
          device_id: "",
          shop_name: "",
          online: "",
          type: "",
          model: "",
          sn: this.$route.query.sn || "",
          name: "",
          sversion: "",
          pversion: "",
        },
        commitItem: null,
        // 统计
        countList: [
          {name: "设备总数", count: 0},
          {name: "在线", count: 0, color: "#0cca8e"},
        ],
        // 表格数据
        tableData: {
          tableList: [],
          tableColumn: [
            {label: "设备ID", property: "id", width: 70},
            {label: "所属商家", property: "shopName"},
            {label: "状态", property: "online", format: deviceOnline, width: 60},
            {label: "设备类型", property: "type", format: deviceType, width: 90},
            {label: "设备名称", property: "name"},
            {label: "设备型号", property: "model"},
            {label: "设备SN", property: "sn",width: 190},
            {label: "设备版本", property: "sversion", width: 150},
            {label: "插件版本", property: "pversion"},
            {label: "上线时间", property: "login_at"},
            {label: "运行时间", property: "start_at"},
          ],
          // 展开项
          hasExpand: true,
          expandLabelWidth: 120,
          expandColumn: [
            {label: "状态", property: "online", format: deviceOnline},
            {label: "设备类型", property: "type", format: deviceType},
            {label: "设备名称", property: "name"},
            {label: "所属商家", property: "shop.name"},
            {label: "设备型号", property: "model"},
            {label: "设备SN", property: "sn"},
            {label: "设备版本", property: "sversion"},
            {label: "WAN口IP", property: "wan_ip"},
            {label: "WAN口MAC", property: "wan_mac"},
            {label: "LAN口IP", property: "lan_ip"},
            {label: "LAN口MAC", property: "lan_mac"},
            {label: "设备上线时间", property: "login_at"},
            {label: "设备离线时间", property: "logout_at"},
            {label: "更新时间", property: "update_at"},
            {label: "首次上线时间", property: "create_at"},
            {label: "设备硬件平台", property: "plat"},
            {label: "设备运行时间", property: "start_at", formatFun: this.formatRuntime},
            {label: "TELNET端口", property: "telnet_port", format: deviceFunction},
            {label: "HTTP端口", property: "http_port", format: deviceFunction},
            {label: "HTTPS端口", property: "https_port", format: deviceFunction},
            {label: "AC端口", property: "ac_http_port", format: deviceFunction},
            {label: "设备账号", property: "account"},
            {label: "设备密码", property: "password"},
            {label: "插件版本", property: "pversion"},
            {label: "公网IP", property: "public_ip"},
            {label: "自定义型号", property: "model_x"},
            {label: "最后上线位置", property: "login_city", formatFun: this.formatLocation},
            {label: "设备LOGO", property: "logo"},
            {label: "今日离线数", property: "today_offline_count"},
          ]
        },
      }
    },
    methods: {
      /**格式化*/
      formatRuntime(row) {
        if (!row.start_at || !row.online) {return "-"}
        let nowTime = new Date().getTime() / 1000;
        let time = nowTime - row.start_at;
        return this.timeStamp(time);
      },
      formatLocation(row) {
        let province = row?.login_city?.province;
        let city = row?.login_city?.city;
        if (!province && !city) return "-";
        return `${province}${city ? " - " + city : ""}`;
      },
      /**单个操作*/
      //远程
      async remote(row, type) {
        let newPage = window.open();
        this.drawNewPage(newPage);
        let nv = {
          shop_id: row.id,
          sn: row.sn,
          type,
        };
        let res = await this.$Http.remoteDevice(nv);
        if (res?.data) {
          newPage.location.href = res.data.url;
        } else {
          newPage.close();
        }
      },
      /**其他*/
      // 查询
      search() {
        this.commitItem = {...this.searchItem};
        this.pagingData.currentPage = 1;
        this.getTableList();
      },
      //获取表格数据
      async getTableList() {
        let nv = {
          page: this.pagingData.currentPage,
          limit: this.pagingData.pageSize
        };
        // 添加筛选项
        this.copyObjValue(nv, this.commitItem);
        let res = await this.$Http.getDeviceList(nv);
        if (res?.data) {
          let total = +res.data.total || 0;
          this.pagingData.total = total;
          this.countList[0].count = total;
          this.countList[1].count = +res.data.online || 0;
          this.tableData.tableList = this.getArray(res.data.list);
        }
      },
    },
    created() {
      this.search();
    }
  }
</script>

<style scoped>

</style>
